import "../css/banner.css"



// This is the pink background for the sidebar.
export default function SideBarBackground(props) {

    return (
        <div class="SideBarBackground">
        </div>
    )
}